"use strict";

var _classCallCheck = require("C:\\Users\\Drews\\Lambda\\Personal Projects\\BlockStack-App\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\Drews\\Lambda\\Personal Projects\\BlockStack-App\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var authConstants_1 = require("./authConstants");

var utils_1 = require("../utils");
/**
 * Configuration data for the current app.
 *
 * On browser platforms, creating an instance of this
 * class without any arguments will use
 * `window.location.origin` as the app domain.
 * On non-browser platforms, you need to
 * specify an app domain as the second argument.
 *
 */


var AppConfig =
/*#__PURE__*/
function () {
  /**
   * @param {Array<string>} scopes - permissions this app is requesting
   * @param {string} appDomain - the app domain
   * @param {string} redirectPath - path on app domain to redirect users to after authentication
   * @param {string} manifestPath - path relative to app domain of app's manifest file
   * @param {string} coreNode - override the default or user selected core node
   * @param {string} authenticatorURL - the web-based fall back authenticator
   * ([[DEFAULT_BLOCKSTACK_HOST]])
   */
  function AppConfig() {
    var scopes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : authConstants_1.DEFAULT_SCOPE.slice();
    var appDomain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : utils_1.getGlobalObject('location', {
      returnEmptyObject: true
    }).origin;
    var redirectPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var manifestPath = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '/manifest.json';
    var coreNode = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var authenticatorURL = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : authConstants_1.DEFAULT_BLOCKSTACK_HOST;

    _classCallCheck(this, AppConfig);

    this.appDomain = appDomain;
    this.scopes = scopes;
    this.redirectPath = redirectPath;
    this.manifestPath = manifestPath;

    if (!coreNode) {
      this.coreNode = authConstants_1.DEFAULT_CORE_NODE;
    } else {
      this.coreNode = coreNode;
    }

    this.authenticatorURL = authenticatorURL;
  }
  /**
   * The location to which the authenticator should
   * redirect the user.
   * @returns {string} - URI
   */


  _createClass(AppConfig, [{
    key: "redirectURI",
    value: function redirectURI() {
      return "".concat(this.appDomain).concat(this.redirectPath);
    }
    /**
     * The location of the app's manifest file.
     * @returns {string} - URI
     */

  }, {
    key: "manifestURI",
    value: function manifestURI() {
      return "".concat(this.appDomain).concat(this.manifestPath);
    }
  }]);

  return AppConfig;
}();

exports.AppConfig = AppConfig;